
/**
 * 生成唯一标识符
 *
 * @export
 * @returns
 */
export function guid() {
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
}
function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}


/**
 * 判断是否是新iphone
 *
 * @export
 * @returns
 */
export function getisNewIphone() {
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isIOS) {
        if (window.screen.height === 812 && window.screen.width === 375) {
            return true;
        } else {
            return false;
        }
    }
}
